require('./../bootstrap');

window.Vue = require('vue');

let eventHub = new Vue();
Vue.prototype.$eventHub = eventHub;
window.$eventHub = eventHub;

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
    preLoad: 3,
    lazyComponent: true
});
Vue.config.ignoredElements = [
    'zapier-app-directory'
];
// import scrollmagic from 'scrollmagic';
// window.ScrollMagic = scrollmagic;

require('./../metronic.js');

Vue.component('Application', require('./components/Application.vue'));
Vue.component('Subscribe', require('./components/Subscribe.vue'));
Vue.component('EbookSubscribe', require('./components/EbookSubscribe.vue'));
Vue.component('EbookSubscribeModal', require('./components/EbookSubscribeModal.vue'));
Vue.component('SubscribeWebinar', require('./components/SubscribeWebinar.vue'));

Vue.component('Slider', require('./components/Slider.vue'));
Vue.component('CommentSlider', require('./components/CommentSlider.vue'));
Vue.component('ContactForm', require('./components/ContactForm.vue'));
Vue.component('EnterpriseContactForm', require('./components/EnterpriseContactForm.vue'));
Vue.component('AcademyWaitlistForm', require('./components/AcademyWaitlistForm.vue'));

Vue.component('PricingForm', require('./components/PricingForm.vue'));
// Vue.component('PricingPlan', require('./components/PricingPlan.vue'));
Vue.component('Modal', require('./components/Modal.vue'));
Vue.component('Accord', require('./components/Accord.vue'));
Vue.component('FaqAccord', require('./components/FaqAccord.vue'));
// Vue.component('LifetimeOffer', require('./components/LifetimeOffer.vue'));
// Vue.component('AddComment', require('./comments/AddComment.vue'));
Vue.component('OrganizeSlider', require('./components/OrganizeSlider.vue'));
// Vue.component('BuildingSlider', require('./components/BuildingSlider.vue'));
// Vue.component('RoadmapSlider', require('./components/RoadmapSlider.vue'));
Vue.component('ReviewsSlider', require('./components/ReviewsSlider.vue'));
Vue.component('SwiperSlider', require('./components/SwiperSlider.vue'));
Vue.component('PricingPage', require('./components/PricingPage.vue'));
Vue.component('WhitelabelPricingPage', require('./components/WhitelabelPricingPage.vue'));

Vue.component('PricingCalculator', require('./components/PricingCalculator.vue'));

// Vue.component('PricingPageMonthly', require('./components/PricingPageMonthly.vue'));
Vue.component('StripeCheckout', require('./components/StripeCheckout.vue'));
Vue.component('TemplatesSlider', require('./components/TemplatesSlider.vue'));
Vue.component('TemplatesSliderLight', require('./components/TemplatesSliderLight.vue'));
Vue.component('ViewsSlider', require('./components/ViewsSlider.vue'));
Vue.component('ViewsImagesSlider', require('./components/ViewsImagesSlider.vue'));
Vue.component('AutomationsSlider', require('./components/AutomationsSlider.vue'));
Vue.component('PhSlider', require('./components/PhSlider.vue'));
Vue.component('FbSlider', require('./components/FbSlider.vue'));
Vue.component('PhMobileSlider', require('./components/PhMobileSlider.vue'));
// Vue.component('PricingSlider', require('./components/PricingSlider.vue'));
// Vue.component('PricingFiveSlider', require('./components/PricingFiveSlider.vue'));
Vue.component('FeaturesViews', require('./components/FeaturesViews.vue'));
Vue.component('DarkTemplatesSlider', require('./components/DarkTemplatesSlider.vue'));
Vue.component('BenefitsSlider', require('./components/BenefitsSlider.vue'));
Vue.component('Integrations', require('./components/Integrations.vue'));
Vue.component('Swiper', require('./components/Swiper.vue'));
Vue.component('TestimonialsSwiper', require('./components/TestimonialsSwiper.vue'));
Vue.component('SwiperFeaturesNavigation', require('./components/SwiperFeaturesNavigation.vue'));
// Vue.component('LtdGuideBanner', require('./components/LtdGuideBanner.vue'));
Vue.component('BlogSubscribeForm', require('./components/BlogSubscribeForm.vue'));
Vue.component('TopAlternatives', require('./components/TopAlternatives.vue'));

Vue.component('AcademyCheckout', require('./components/AcademyCheckout.vue'));

// Vue.component('StackedCardsSlider', require('./components/StackedCardsSlider.vue'));

Vue.component('EchoPricing', require('./components/EchoPricing.vue'));
Vue.component('EchoSubscribe', require('./components/EchoSubscribe.vue'));

Vue.component('MegaNav', require('./components/MegaNav.vue'));

new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/js/frontend/app.js